import { UPDATE_MSISDN } from '.';

export default function updateMsisdn(msisdn) {
  return dispatch => {
    dispatch({ type: UPDATE_MSISDN, msisdn });
  };
}
